import { assert } from "@/common/assert";

export interface ImageSize {
    width: number;
    height: number;
}

export function getImageSize(url: string): Promise<ImageSize> {
    assert(url, "url is falsy");
    return new Promise((resolve, reject) => {
        const img = document.createElement("img");
        img.onload = (_) => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
        };
        img.onerror = (error) => {
            const e = new Error("failed with error: " + error);
            console.error("get image size of ", url, "failed with error", error);
            reject(e);
        };
        img.src = url;
    });
}

export function parseSizeFromImageUrl(url: string): ImageSize | undefined {
    const urlRegex = /(\d+x\d+)/g;
    const result = url.match(urlRegex);
    if (result && result.length) {
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        const tokens = url.match(urlRegex)![0].split("x");
        assert(tokens.length === 2, "parse image width & height failed: " + url);
        const nums = tokens.map((t) => parseInt(t, 10));
        return { width: nums[0], height: nums[1] };
    }
    return;
}
